import React, { useState, useEffect } from 'react';
import ENDPOINTS from '../config/apiEndPoints';
import LoadingSpinner from "./LoadingSpinner";
import styles from './Trends.module.css';

const Trends = () => {
  const [candidates, setCandidates] = useState([]); // State to store candidate data
  const [loading, setLoading] = useState(true); // To handle loading state
  const [error, setError] = useState(null); // To handle error state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const timestamp = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
        const response = await fetch(`${ENDPOINTS.TRENDS}?ver=${timestamp}`);
        if (!response.ok) {
          throw new Error('Failed to fetch updates');
        }
        let data = await response.json();
        setCandidates(data?.items || []); // Assuming the data has a 'candidates' key
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred');
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs once on mount

  if (loading) {
    return <LoadingSpinner />;
  }
  if (error) return null;

  return (
    <div className={`election-results-inner live-updates ${styles.trendsContainer}`}>
    <div className={styles.trends}>
      {candidates.map((candidate, index) => (
        <div key={index} className={styles.trendsItem}>
          <div>
            <img src={candidate.Photo} alt={candidate.Cand_Name_English} width={70} height={70} className={styles.candidateImage} />
            <div>
              <span className={styles.candidateName}>{candidate.Cand_Name_English}</span>
              <span className={`${styles.front} ${candidate.Front.toLowerCase()}-bg`}>{candidate.Front}</span>
              <span className={styles.lbName}>{candidate.Local_Body}</span>
            </div>
          </div>
          <div className={styles.status}>
            {candidate.Status && <img
              src={`${process.env.PUBLIC_URL}/assets/${candidate.Status.toLowerCase()}.svg`}
              alt={candidate.Status}
            />}
            {candidate.Lead_Trail && candidate.Lead_Trail > 0 && (
              <>
                <span>{candidate.Status.toUpperCase()} BY</span>
                <span className={`${candidate.Status.toLowerCase()}-color`}>{candidate.Lead_Trail}</span>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default Trends;
